var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzerbaijan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 10.5322 23.736 9.12605 23.2536 7.82611L12 7.30434L0.746391 7.82606C0.264047 9.12605 0 10.5322 0 12C0 13.4678 0.264047 14.874 0.746391 16.1739L12 16.6957L23.2536 16.1739C23.736 14.874 24 13.4678 24 12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C17.1596 24 21.5581 20.7435 23.2536 16.1739H0.746399C2.44191 20.7435 6.84043 24 12 24Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.746399 7.82611H23.2537C21.5581 3.2565 17.1596 0 12 0C6.84043 0 2.44191 3.2565 0.746399 7.82611Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2609 15.3913C10.3879 15.3913 8.86954 13.8729 8.86954 12C8.86954 10.1271 10.3879 8.60869 12.2609 8.60869C12.8448 8.60869 13.3943 8.75634 13.8741 9.01631C13.1214 8.28033 12.0922 7.82606 10.9565 7.82606C8.6513 7.82606 6.78262 9.69478 6.78262 12C6.78262 14.3051 8.65134 16.1738 10.9565 16.1738C12.0923 16.1738 13.1215 15.7196 13.8741 14.9836C13.3943 15.2437 12.8448 15.3913 12.2609 15.3913Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8696 9.65217L15.3188 10.9155L16.5297 10.3398L15.9541 11.5507L17.2174 12L15.9541 12.4492L16.5297 13.6602L15.3188 13.0845L14.8696 14.3478L14.4204 13.0845L13.2094 13.6602L13.7851 12.4492L12.5217 12L13.7851 11.5507L13.2094 10.3398L14.4204 10.9155L14.8696 9.65217Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzerbaijan);
export default __webpack_public_path__ + "static/media/azerbaijan.aa6162f7b628dd6b6af9be154ae49201.svg";
export { ForwardRef as ReactComponent };